import { render, staticRenderFns } from "./EditSupervisor.vue?vue&type=template&id=66379317&"
import script from "./EditSupervisor.vue?vue&type=script&lang=js&"
export * from "./EditSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./EditSupervisor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports